/**
 * ReleaseChannelBadge Component
 * Displays release channel as a colored chip
 */

import React from 'react';
import { Chip } from '@mui/material';
import { RELEASE_CHANNEL_LABELS, RELEASE_CHANNEL_COLORS } from '../../utils/constants';

export const ReleaseChannelBadge = ({ channel }) => {
  const label = RELEASE_CHANNEL_LABELS[channel] || channel;
  const color = RELEASE_CHANNEL_COLORS[channel] || 'default';

  return (
    <Chip
      label={label}
      color={color}
      size="small"
      variant="outlined"
      sx={{ fontWeight: 500 }}
    />
  );
};
